import { MainProductSelection } from 'services/api/entities/events/types/internal/selections'
import { yupIgnore, YupSchema } from 'services/yup'
import { productSelectionBaseVS } from './base'

export const mainProductSelectionVS: YupSchema<MainProductSelection> =
  productSelectionBaseVS.shape({
    isPrivate: yupIgnore(),
  })
